export function normalizeInternationalPhoneInput(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const normalized = raw.replace(/[^\d+]/g, "");
  if (!normalized) return "";
  if (normalized.startsWith("+")) {
    return `+${normalized.slice(1).replace(/\+/g, "")}`;
  }
  return normalized.replace(/\+/g, "");
}

export function isInternationalPhone(value) {
  const normalized = normalizeInternationalPhoneInput(value);
  return /^\+[1-9]\d{7,14}$/.test(normalized);
}
